import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation-10";
import SEOFooterSubmenu from "./SEOFooterSubmenu.esm.js";
const seoFooterWrapperStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))",
  gap: "loose",
  lgDown: {
    gridTemplateColumns: "repeat(1, minmax(0, 1fr))"
  },
  "& > *": {
    position: "relative",
    textAlign: "center",
    lg: {
      "&::before": {
        content: '" "',
        width: "1px",
        height: "600",
        position: "absolute",
        top: "tight",
        right: "tightest",
        backgroundColor: "gray.400"
      },
      "&:last-of-type::before": {
        display: "none"
      }
    }
  }
};
const SEOFooter = ({
  submenuItems
}) => /* @__PURE__ */ jsx(Box, { css: seoFooterWrapperStyles, children: submenuItems.map((submenuItem) => /* @__PURE__ */ jsx(SEOFooterSubmenu, { ...submenuItem }, submenuItem == null ? void 0 : submenuItem.label)) });
export {
  SEOFooter as default
};
